import BoltSolid from 'assets/icons/fa/bolt-solid.svg'

BoltSolid.displayName = 'BoltSolid'
export default BoltSolid
